// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"jR-z","categoryName":"kR-z","categoryNameSearchHeader":"lR-z","categoryContent":"mR-z","bottomAligned":"nR-z","image":"oR-z","imageNoBackground":"pR-z"};